import { createSelector } from 'reselect';
import { State } from 'store/types';
import { createSelectorCached } from 'types/types';

export const selectTasks = (state: State) => state.tasks;

export const selectTasksAssigned = createSelector(
  selectTasks,
  (tasks) => tasks.tasksAssigned,
);

export const selectTasksAssignedItems = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.items,
);

export const selectTasksAssignedDueGroups = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.dueGroups,
);

export const selectTasksAssignedIsLoading = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.isLoading,
);

export const selectTasksAssignedIsLoaded = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.isLoaded,
);

export const selectTasksAssignedError = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.error,
);

export const selectTasksAssignedFilter = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.filter,
);

export const selectTasksAssignedSearch = createSelector(
  selectTasksAssignedFilter,
  (filter) => filter.search,
);

export const selectTasksAssignedFilterDueDateFrom = createSelector(
  selectTasksAssignedFilter,
  (filter) => filter.dueDateFrom,
);

export const selectTasksAssignedFilterDueDateTo = createSelector(
  selectTasksAssignedFilter,
  (filter) => filter.dueDateTo,
);

export const selectTasksAssignedFilterStatuses = createSelector(
  selectTasksAssignedFilter,
  (filter) => filter.statuses,
);

export const selectTasksAssignedFilterOrganisations = createSelector(
  selectTasksAssignedFilter,
  (filter) => filter.organisations,
);

export const selectTasksAssignedFilterProperties = createSelector(
  selectTasksAssignedFilter,
  (filter) => filter.properties,
);

export const selectTasksAssignedFilterOptions = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.filterOptions,
);

export const selectTasksAssignedDraftFilterOptions = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.filterOptionsDraft,
);

export const selectTasksAssignedFilterOptionsLoadStatus = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.filterOptionsLoadStatus,
);
export const selectTaskDetailsState = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.taskDetails,
);

export const selectTasksAssignedIsTaskSelected = createSelectorCached(
  [selectTaskDetailsState, (_: State, taskId: string) => taskId],
  (taskDetails, taskId) => taskDetails.id === taskId,
);

export const selectTaskPaginationDetails = createSelector(
  selectTasksAssigned,
  (tasks) => tasks.taskPagination,
);
